<p-multiselect
  [selectAll]="null"
  [filter]="true"
  [options]="countryList"
  [disabled]="disabled()"
  [ngModel]="countries"
  (ngModelChange)="countries = $event; onCountryChange($event)"
  maxSelectedLabels="5"
  placeholder="Please select"
  selectedItemsLabel="{0} selected"
  appendTo="body"
>
</p-multiselect>
